import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icon/arrow_down.svg")